import * as Highcharts from 'highcharts';
import { BaseChartProps } from '../types/chartProps';
import { createSeriesElementClickHandler } from './seriesUtils';

export function applyPlotSeriesOptions(options: Highcharts.Options, params: BaseChartProps) {
  options.plotOptions = {
    ...options.plotOptions,
    series: {
      ...options.plotOptions?.series,
      cursor: params.onSeriesElementClick ? 'pointer' : 'default',
      point: {
        events: {
          click: createSeriesElementClickHandler(params.onSeriesElementClick, 'bar')
        }
      }
    }
  };
  return options;
}
